module.exports = __webpack_public_path__ + "static/img/img_2.5c7ac3a5.jpg";